export const PaymentsTabId = {
  TRANSACTION_HISTORY: 'transaction-history',
  CRYPTO_PAYMENTS: 'crypto-payments',
  CHANNEL_PAYMENTS: 'channel-payments',
} as const

export type PaymentsTabId = (typeof PaymentsTabId)[keyof typeof PaymentsTabId]
